import React from 'react';
import { ListCarousel } from 'types/ListAndDetailTypes';
import ListItemWithIcon from '../ListItemWithIcon/ListItemWithIcon';
import { EntityComplaint } from 'types/EntityComplaint';
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ListItemCarousel.scss";

const ListItemCarousel: React.FC<ListCarousel> = ({ complaints, header, subHeader = '' }) => {
    var settings: Settings = {
        centerMode: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: complaints.length - 1,
        arrows: false,
        centerPadding: '50px',
    };

    return (
        <div >
            <h3 className='title-as-card'>{header}</h3>
            {subHeader && <h5 className="fs-6">{subHeader}</h5>}
            <Slider {...settings}>
                {complaints.map((item: EntityComplaint) => (
                    <div key={item.id} className='cardBI carouselCard'>
                        <ListItemWithIcon key={item.id} complaint={item} isDecorationIcon={true}/>
                    </div>)
                )}
            </Slider>
        </div>
    );
}

export default ListItemCarousel;
